<div class="container" style="margin-top: 126px">
  <div class="row g-0 gx-lg-0 breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
    </div>

  </div>

  <div class="amc-header">
        <h3 class="fonSize mb-3 d-flex">Select the AMC plans for application selected </h3>
        <!-- <p class="link">Select another segment</p> -->
  </div>
  <div class="step-container" *ngIf="isStepVisible">
    <div class="step">
        <div class="step-icon completed">1</div>
        <div class="step-line"></div>
        <div class="step-icon pending">2</div>
    </div>

    <div class="step">
        <span class="description">Select AMC plan for Construction Aggregates</span>
        <span class="description">Select add-on and Tenure for Construction Aggregates</span>
    </div>
  </div>

  <div class="plan-section mt-4"  *ngIf="!isVisible">
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-4" *ngFor="let element of amcData; let i = index">
        <div class="card plan-card h-100" [ngClass]="{ currentcard: currentIndex == i }" (click)="clickCard(i)">
          <div class="card-body">
            <div class="plan-title">
              <img [src]="environment1 + 'assets/images/' + getAmcTypeImage(element.amc_type) + '.png'"
                   alt="{{ getAmcTypeDisplay(element.amc_type) }}"
                   class="plan-icon" />
              <span style="font-size: 20px">{{ getAmcTypeDisplay(element.amc_type) }}</span>
            </div>
            <div class="d-flex mb-4 pppp">
              <h2 class="plan-price">{{ element.amount_payable | currency:'INR':'symbol':'4.0-0'}}</h2>
              <p class="plan-subtext">per vehicle</p>
            </div>
            <div>
              <span style="color: #0a0a5f;" class="service-tenure" >{{annualKmhr}} {{ annual_kmsroute | number: '1.0-0'}}</span><br>
              <!-- <span style="color: #0a0a5f;" class="service-tenure" *ngIf="subLob== 'hcv-const'">Annual Contract Hrs- {{ annual_kmsroute}}</span><br> -->
              <span style="color: #0a0a5f;" *ngIf="amc_durationroute">Contract Duration(in yrs)- {{ amc_durationroute/12 }}</span>
            </div><br>
            <ul class="plan-features" *ngIf="element.amc_type == 'Platinum Plus'">
              <li *ngFor="let item of platinumplusFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'Platinum'">
              <li *ngFor="let item of platinumFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'Silver'">
              <li *ngFor="let item of silverFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'Gold'">
              <li *ngFor="let item of goldFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'Bronze'">
              <li *ngFor="let item of bronzeFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'Gold plus'">
              <li *ngFor="let item of goldplusFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'FMS Pack-1' || element.amc_type == 'FMS-1'">
              <li *ngFor="let item of FMSPackOneFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <ul class="plan-features" *ngIf="element.amc_type == 'FMS Pack-2'|| element.amc_type == 'FMS-2'">
              <li *ngFor="let item of FMSPackTwoFeature">
                <img [src]='environment1 + "assets/images/check.png"' alt="{{element.amc_type}}" /> {{ item }}
              </li>
            </ul>
            <div class="text-center mt-4">
              <button type="button" (click)="selectPlan(element)" class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100">
                Select and continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="btn col-12 col-lg-12" style="background: #EEEEEE; color: navy; margin-bottom: 20px;"
     data-bs-toggle="modal"
                data-bs-target="#booking_amc"
                (click)="seeFull()"
>
      <span>See Full comparision</span>
    </div> -->
  </div>
  <div class="plan-section mt-4" *ngIf="isVisible">
    <div class="row" *ngFor="let item of carddata">
      <!-- Service Card 1 -->
      <div class="col-md-3 mb-3" *ngIf="item.price_of_extended_warranty !== ''">
        <div class="card h-100" >
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="extendedWarranty"
                [(ngModel)]="isExtendedWarrantyChecked"
                (change)="sliderDatachange()"/>
                 <label class="form-check-label" for="extendedWarranty">Extended Warranty</label>
              </div>
              <span class="badge bg-light text-primary">Recommended</span>
            </div>
            <h3 class="plan-price mt-3">₹{{item.price_of_extended_warranty}}</h3>
            <a href="#" class="text-primary">Know More</a>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="row col-12 col-lg-12 mt-3 d-flex justify-content-between" *ngIf="isVisible">
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
      <h4>Annual Running</h4>
      <div class="slider-container" >
        <div class="d-flex justify-content-between">
          <label for="rangeSlider1" class="chasis_no">No of Kms</label>
          <span style="color: navy">{{value1}}kms</span>
        </div>
        <ngx-slider class="mt-5" [(value)]="value1" [options]="options" (valueChange)="onSliderChange()"></ngx-slider>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
      <h4>Tenure Plan</h4>
      <div class="slider-container" >
        <div class="d-flex justify-content-between">
          <label for="rangeSlider2" class="chasis_no">No of Years</label>
          <span style="color: navy">{{value2 / 12}}Years</span>
        </div>

        <ngx-slider class="mt-5"  [(value)]="value2" [options]="options1" (valueChange)="onSliderChange()"></ngx-slider>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isVisible" class="container-fluid p-3 mt-3 col-12 col-lg-12 position-sticky bottom-0 bg-light shadow-lg rounded amc-footer" style="z-index: 1000;">
  <div class="row">
    <div class="col-6 col-lg-6 sm-12 ps-3">
      <div class="amount">
        <p class="fs-3 fw-bold d-block mb-0">
          {{ value | currency : "INR" : "symbol" : "4.0-0" }}
        </p>
        <span class="d-block">Amount to be paid for this set</span>
      </div>
    </div>
    <div class="col-6 col-lg-6 sm-12 pe-3 d-flex justify-content-end">
      <button type="button" class="btn btn-primary btn-lg btn-grad-primary col-lg-6" (click)="submitData()">
        Submit & review
      </button>
    </div>
  </div>
</div>

<div class="amcModal model" *ngIf="isAMC" >
  <div class="modal fade" id="booking_amc" tabindex="-1" aria-labelledby="booking_amcLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="d-flex justify-content-end" style="margin-bottom: -43px; z-index: 1;">
          <button type="button" class="btn-close m-1" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="overflow: unset !important;">
          <div class="amc-table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th *ngFor="let plan of amcPlans">{{ plan.name }}</th>
                </tr>
                <tr>
                  <th></th>
                  <th *ngFor="let plan of amcPlans" class="price">{{ plan.price | currency:'INR':'symbol':'1.0-0' }} <span class="peryear"> per vehicle</span></th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                  <td></td>
                  <td *ngFor="let plan of amcPlans" class="price">{{ plan.price | currency:'INR':'symbol':'1.0-0' }}</td>
                </tr> -->
                <tr *ngFor="let feature of features">
                  <td>{{ feature.name }}</td>
                  <td *ngFor="let plan of amcPlans">
                    <span *ngIf="feature.includedIn.includes(plan.id)" class="checkmark">✓</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
